import { Stack } from 'expo-router';

export default function ClubsTabLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
